<template>
    <v-dialog v-model="modal" :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" :width="width" scrollable>
        <v-card class="fondo-curso-modal">
            <v-toolbar class="cerrar">
                <button v-if="mostrarCerrar" @click="$emit('click', false)" class="hvr hvr-scale iconcerrar">
                    <v-icon class="icon">close</v-icon>
                </button>
            </v-toolbar>
            <v-card-text>
                <v-flex contain class="dialog-content" text-xs-center>
                    <slot name="modalcontent"></slot>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        model: {
            prop: 'modal',
            event: 'click'
        },
        props: {
            modal: Boolean,
            width: {
                type: String,
                default: '700px'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../sass/helpers/variables';
    
    .cerrar {
        padding-bottom: 0;
        height: 35px;
        background: white;
        box-shadow: none;
        display: flex;
        justify-content: center;
        align-items: center;
        .iconcerrar{
            position: absolute;
            top: 2px;
            right: 2px;
            .icon{
                color: $color-primary;
            }
        }
    }

    .dialog-content {
        max-width: 1100px;
        // max-width: 100%;
        margin: auto;
        padding: 5px;
        margin-top: -10px;
        align-items: center;
        @media (max-height: 800px){
            align-items: start;
        }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal {
        background: white;
        border-radius: 7px;
    }

</style>
